import React from 'react';
import SearchInput from '../SearchInput';
import { producaov2 } from '../../../../../services/apis';

const courseRequest = async (search) => {
  const response = await producaov2.get(`cursos-simplelist?search=${search}&limit=15`);
  return response.data?.map(course => ({id: course?.id, name: `[${course?.id}] ${course?.curso}`}));
}

export default function CourseSearch({ selectedCourse, onChangeSelectedCourse, errorMessage }) {
  return (
    <SearchInput
      label="Selecione o Curso"
      searchRequest={courseRequest}
      selectedOption={selectedCourse}
      onChangeSelectedOption={onChangeSelectedCourse}
      errorMessage={errorMessage}
    />
  );
}